<template>
  <div id="app">
    <div id="container">
      <Header />
      <Home />
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./views/Header.vue";
import Home from "./views/Home.vue";

export default {
  name: "app",

  components: { Header, Home },
  data() {
    return {};
  },

  created() {},
  methods: {},
};
</script>


<style>
html {
  background: #110000;
}
#app {
  font-family: "Prompt", sans-serif;
  background: #110000;
}
#header {
  margin: 0px auto;
  width: 800px;
  text-align: center;
}

#container {
  width: 50%;
  /*height: 550px; */
  margin: 0px auto;
  padding: 1px;
  background: #ffffff;
}
thead {
  background: #110000;
  color: #ffffff;
}
th {
  font-size: 14px;
}
td {
  font-size: 14px;
}
h1,
h2,
h3,
h4,
h5,
h6,
b {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.text-box {
  background: #110000;
  color: white;
}
@media (max-width: 575.98px) {
  #container {
    width: 100%;
  }
}
</style>
